module.exports = __webpack_public_path__ + "static/media/reapply-docs.7d2236da.svg";